import WebFontLoader from 'webfontloader'

// async load fonts
// 폰트 소스
WebFontLoader.load({
  google: {
    families: [
      'Archivo',
      'JetBrains Mono',
      'Nanum Myeongjo',
      'Black Han Sans',
      'Nanum Gothic Coding',
      'Nanum Pen Script:400',
      'Noto Sans Korean',
    ],
  },
  // custom: {
  //   families: ['NanumGothic'],
  //   urls: ['https://hangeul.pstatic.net/hangeul_static/css/NanumGarMaesGeur.css'],
  // },
})
